import { useSearchParams } from 'react-router-dom'
import {
  getAuth,
  confirmPasswordReset,
  verifyPasswordResetCode
} from 'firebase/auth'
import { useEffect, useState } from 'react'

type FormKeys = 'password' | 'confirmPassword'

type ErrorMap = Map<FormKeys, string>

const useRecovery = () => {
  const [searchParams] = useSearchParams()
  const oobCode = searchParams.get('oobCode')
  const [state, setState] = useState<IStateStdTypes>('idle')
  const [actionState, setActionState] = useState<IStateStdTypes>('idle')
  const [password, setPassword] = useState('')
  const [confirmPwd, setConfirmPwd] = useState('')
  const auth = getAuth()
  const [errorsMap, setErrorsMap] = useState<ErrorMap>(new Map())

  const disableAction =
    password.length == 0 || confirmPwd.length == 0 || actionState == 'loading'

  const checkPwdResetCode = async () => {
    try {
      await verifyPasswordResetCode(auth, oobCode!)
      setState('success')
    } catch (e) {
      setState('error')
    }
  }

  useEffect(() => {
    checkPwdResetCode()
  }, [oobCode, auth])

  const validateForm = (): ErrorMap => {
    const newErrorsMap: ErrorMap = new Map()

    if (password.length < 6) {
      newErrorsMap.set('password', 'Mínimo 6 dígitos')
    }
    if (confirmPwd == '') {
      newErrorsMap.set('confirmPassword', 'Confirme a sua senha')
    } else if (confirmPwd != password) {
      newErrorsMap.set('confirmPassword', 'Senhas não conferem')
    }

    errorsMap.clear()

    setErrorsMap(newErrorsMap)

    return newErrorsMap
  }

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (actionState !== 'loading' && state === 'success') {
      const errors = validateForm()
      if (errors.size != 0) return
      setActionState('loading')
      try {
        await confirmPasswordReset(auth, oobCode!, password)
        setActionState('success')
      } catch (err) {
        setActionState('error')
      }
    }
  }

  const changeFieldValue = (item: FormKeys, value: string) => {
    switch (item) {
      case 'password':
        setPassword(value)
        break
      case 'confirmPassword':
        setConfirmPwd(value)
        break
    }

    errorsMap.delete(item)
  }

  return {
    onSubmit,
    state,
    actionState,
    errorsMap,
    changeFieldValue,
    password,
    confirmPwd,
    disableAction
  }
}

export default useRecovery
